<div class="content-left-top-cornor">
  <p-tabView>
    <p-tabPanel headerStyleClass="selected" header="Sample Reception Cell">
      <p-blockUI [blocked]="blocked">
        <div id="center" style="margin-top:260px; margin-left:800px;">
          <p-progressSpinner [style]="{width: '100px', height: '200px'}" strokeWidth="6"></p-progressSpinner>
        </div>
      </p-blockUI>
      <div class="container-fluid mt-0">
        <div class="row">
          <div class="col-12 flex pt-0 pb-0">
            <div class="col-3">
              <div class="row m-0 p-0">
                <div class="col-11 pt-2"></div>
                <div class="col-1" id="refreshBatchesDiv">
                  <button pButton class="refreshBatches" icon="fa fa-refresh" (click)="reloadRuns()"></button>
                </div>
              </div>
              <div class="row m-0 p-0">
                <div class="col-11 pt-2" id="multiselectDiv">
                  <div class="ui-inputgroup mb-0" id="filterLabel">
                    <button pButton class="theme-button noHover labelButton" type="button" label="Workflow"></button>
                    <p-multiSelect [options]="workFlowList" name="workFlowList" (onChange)="onApplyFilter()" [(ngModel)]="workFlowNameList"
                      id="multiselectStatuses" placeholder="Sel. Workflow" [maxSelectedLabels]="1" styleClass="multiSelectionDropdown">
                      <ng-template let-item pTemplate="selectedItem">
                        <span style="vertical-align:middle">{{item.label}}</span>
                      </ng-template>
                      <ng-template let-status pTemplate="item">
                        {{status.label}}
                      </ng-template>
                    </p-multiSelect>
                  </div>
                </div>
      
                <div class="col-1 pt-2" id="refreshBatchesDiv">
                  <button pButton class="refreshBatches resetButton" icon="pi pi-times" (click)="resetAllFilter()"></button>
                </div>
              </div>
              <div class="row m-0 p-0">
                <div class="col-11 pt-2" id="multiselectDiv">
                  <div class="ui-inputgroup" id="datePicker">
                    <button pButton class="theme-button noHover labelButton" type="button" label="Date"></button>
                    <p-calendar [(ngModel)]="fromDate" readonlyInput="true" (onSelect)="onApplyFilter()"
                      dateFormat="dd.mm.yy" [showIcon]="true" placeholder="Sel. Start Date" showButtonBar="true"
                      (onClearClick)="onApplyFilter()" (onTodayClick)="onApplyFilter()">
                    </p-calendar>
                  </div>
                </div>
                <div class="col-1 pt-2"></div>
              </div>
            </div>
            <div class="col-9 pb-0">
              <div class="col-12 flex pt-0 pb-0" id="topGroup">
                <div class="col-4 topDivspacing pr-0" id="topDiv">
                  <div class="ui-inputgroup" id="inputClass">
                    <button pButton class="theme-button noHover labelButton" type="button" label="User ID"></button>
                    <input pInputText name="UserPUID" [value]="puid" size="10" id="userID" maxlength="4" class="inputBox" placeholder="User ID" readonly />
                  </div>
                  <div class="ui-inputgroup" id="inputClass">
                    <button pButton class="theme-button noHover labelButton" type="button" label="Run ID"></button>
                    <input pInputText name="SearchRun" [(ngModel)]="runToSearch" size="10" (keydown.enter)="searchForRun()" class="inputBox" placeholder="Run ID" />
                    <button pButton icon="fa fa-search" class="search-field-blue-end" (click)="searchForRun()">
                    </button>
                  </div>
                  <div class="ui-inputgroup" id="inputClass">
                    <button pButton class="theme-button noHover labelButton" type="button" label="Sample ID"></button>
                    <input pInputText name="SearchSample" [(ngModel)]="sampleToSearch" size="10" (keydown.enter)="searchForSample()" class="inputBox" placeholder="Sample ID"/>
                    <button pButton icon="fa fa-search" class="search-field-blue-end" (click)="searchForSample()">
                    </button>
                  </div>
                </div>
    
                <div class="col-5 topDivspacing pl-0 pr-0" style="text-align: left;">
                  <div class="col-12 flex headers">
                    <h5>
                      Run :<strong>{{selectedRun?.runId}} </strong>
                    </h5>
                  </div>
                  <div class="col-12 flex headers">
                    <h5>
                      Status :<strong> {{selectedRun?.status}}</strong>
                    </h5>
                  </div>
                  <div class="col-12 flex headers">
                    <h5>
                      Project :<strong> {{selectedRun?.projectId}}</strong>
                    </h5>
                  </div>
                  <div class="col-12 flex headers">
                    <h5>
                      Workflow :<strong> {{selectedRun?.workFlow}}</strong>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12 flex pt-0 pb-0">
            <div class="col-3">
              <div class="tableLHS1">
                <p-table [value]="runs" selectionMode="single" (onRowSelect)="fetchRun($event)"
                (onRowUnselect)="removeRunSelection()" [loading]="loading">
                  <ng-template pTemplate="header">
                    <tr>
                      <th class="run" scope="col">Run-ID</th>
                      <th class="status" scope="col">Status</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-run>
                    <tr [pSelectableRow]="run">
                      <td class="leftTable">
                        {{run?.runId}}</td>
                      <td>
                        {{run?.status}}</td> 
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
            <div class="col-9">
              <div class="col-12 flex" id="tableDiv">
                <p-confirmDialog class="confirm-message"></p-confirmDialog>
                <table id="runTable" class="rightTable" aria-describedby="Run Creation Table">
                  <thead id="runTableHeader">
                    <tr>
                      <th scope="col" style="width:40%">Start New Run</th>
                      <th scope="col" style="width:30%">Sample Requests</th>
                      <th scope="col" style="width:30%">Plate Feedback</th>
                    </tr>
                  </thead>
                  <tbody id="runTableBody">
                    <tr>
                      <td id="runTableBody">
                        <div class="col-12 flex">
                          <button pButton label="New Run" type="button" class="buttonsRound startButton" (click)="removeRunSelection()">
                          </button>
                        </div>
                        <div class="col-10">
                          <div class="ui-inputgroup labels " id="inputClass" *ngIf="selectedRun.runId.length !== 0">
                            <button pButton class="theme-button noHover labelButton" type="button" label="Run ID"></button>
                            <input pInputText id="input" placeholder="Run ID" [value]="selectedRun.runId" [disabled]="disableRunFormFields()" readonly />
                          </div>
                        </div>
                        <div class="col-10">
                          <div class="ui-inputgroup" id="inputClass">
                            <button pButton style="font-size: 15px;" class="theme-button noHover labelButton"
                              type="button" label="Project ID"></button>
                            <p-dropdown placeholder="Select Project" filter="true" [options]="projectsList" (onChange)="getSelectedWorkFlowSampleType()" [disabled]="disableRunFormFields()"
                              name="projectList" [(ngModel)]="selectedProject" [showClear]="true">
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="col-10">
                          <div class="ui-inputgroup" id="inputClass">
                            <button pButton style="font-size: 15px;" class="theme-button noHover labelButton"
                              type="button" label="Machine"></button>
                            <p-dropdown placeholder="Select Machine ID" [options]="machinesList" [disabled]="disableRunFormFields()"
                              name="machineList" [(ngModel)]="selectedRun.machineId" [showClear]="true">
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="col-10">
                          <div class="ui-inputgroup" id="inputClass">
                            <button pButton style="font-size: 15px;" class="theme-button noHover labelButton"
                              type="button" label="Line"></button>
                            <p-dropdown placeholder="Select Line Type" [options]="linesList" [disabled]="disableRunFormFields()"
                              name="lineList" [(ngModel)]="selectedRun.line" [showClear]="true" (onChange)="onLineSelected($event)">
                            </p-dropdown>
                          </div>
                        </div>
                        <div class="col-10">
                          <div class="boxIdField ui-inputgroup" id="inputClass">
                            <button pButton class="theme-button noHover labelButton" type="button" label="Box-ID"
                              style="font-size: 15px"></button>
                            <input pInputText name="boxID" (keydown.enter)="searchForBox()"
                              [(ngModel)]="boxIDSearchValue" placeholder="Box ID" />
                          </div>
                          <span *ngFor="let box of selectedRun.boxes; let index=index">
                            <div>
                              <input pInputText [value]="box" style="width: 54%; margin-left: 35%; height: 35px;" readonly/>
                              <button *ngIf="selectedRun.runId === '' || selectedRun.boxes.length > 1" pButton icon="fa fa-times-circle" class="removePopInput" (click)="deleteValue(index)"></button>
                            </div>
                          </span>
                        </div>
                        <div class="col-12 flex" style="display: flex;justify-content: space-between;">
                          <div class="col-8" style="padding-right: 0;">
                            <button pButton label="Start Run" type="button" (click)="startRun()" class="buttonsRound startRunButton" [disabled]="disableStartRunButton()">
                            </button>
                          </div>
                            <div class="col-4" style="padding-left: 0;" *ngIf="isValidProcessStep('CREATE_RUN')">
                              {{getProcessStepStartTimestamp('CREATE_RUN') | date: 'dd.MM.yy HH:mm'}} <br />
                              {{getProcessStepStartPuid('CREATE_RUN')}}
                          </div>
                        </div>        
                      </td>
                      <td id="runTableBody">
                        <div *ngIf="showNoScanDMSamples()">
                          Barcode not scannable: {{selectedRun.noScanDM}} {{selectedRun.sampleType}}  Samples : {{ (selectedRun.samples) ? selectedRun.samples.length : 0}}
                        </div>
                        <div *ngIf="!showNoScanDMSamples()">
                          Samples : {{ (selectedRun.samples) ? selectedRun.samples.length : 0}}</div>
                        <div class="grid-table-right"> 
                          <p-table [value]="selectedRun?.samples" [scrollable]="true" [loading]="loading">
                            <ng-template pTemplate="header">
                              <tr>
                                <th scope="col">Sample-ID</th>
                                <th class="status" scope="col">Status</th>
                              </tr>
                            </ng-template>
                            <ng-template pTemplate="body" let-sample>
                              <tr>
                                <td>{{sample?.sampleId}}</td>
                                <td>{{sample?.status}}</td> 
                              </tr>
                            </ng-template>
                          </p-table>
                        </div>
                      </td>
                      <td id="runTableBody">
                        <div class="grid-table-right"> 
                          <p-table [value]="selectedRun?.plates" [scrollable]="true" [loading]="loading">
                          <ng-template pTemplate="header">
                            <tr>
                              <th class="run" scope="col">Plates Created</th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-plate>
                            <tr [ngClass]="classForDuplicatePlate(plate)" (click)="clickPlateID(plate)" (keydown)="clickPlateID(plate)">
                              <td>{{plate}}</td>
                            </tr>
                          </ng-template>
                          </p-table>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-tabPanel>
  </p-tabView>
</div>
<p-dialog header="Update New PlateID!!" [(visible)]="showDuplicatePlateIdDialog" [modal]="true" position="top" 
  (onHide)="clearPopUpFields()">
  <div>
    <div class="col-12 flex ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="Duplicate ID" style="width: 10rem;"></button>
      <input pInputText name="duplicatePlate" [(ngModel)]="duplicatePlateID" size="5" />
    </div>
    <div class="col-12 flex ui-inputgroup" id="inputClass">
      <button pButton class="theme-button noHover labelButton" type="button" label="New Plate ID"></button>
    <input pInputText name="newPlateID" [(ngModel)]="newPlateID" size="5" (input)="disableUpdateButtonOnChange()"
        (keyup.enter)="checkNewPlateIDPresent()" />
    </div>
  </div>

  <div class="col-12 flex mt-2 add-comment-container">
    <button pButton label="Update New PlateID" id="add-comment" (click)="updateNewPlateIDInPlate()" [disabled]="disableUpdatePlateIDButton"></button>
  </div>
</p-dialog>
